export default __webpack_public_path__ + "static/media/18.7439c015.jpg";